<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Upload de Arquivos</h2>
    </div>

    <div class="tds-row">
        <tds-button
            type="button"
            variant="primary"
            size="lg"
            text="Browse"
            animation="none"
            tds-aria-label="undefined"
            name=""
            value="" style="padding-right: 20px;"
        ></tds-button>

        <tds-dropdown
            name="dropdown"
            label-position="outside"
            placeholder="Escolha a opção"
            size="lg"
            animation="slide"
            open-direction="auto"
            tds-aria-label="A dropdown component" style="padding-right: 20px;">
            <tds-dropdown-option value="option-1">Lista de Créditos</tds-dropdown-option>
            <tds-dropdown-option value="option-2">Follow Up CA</tds-dropdown-option>
        </tds-dropdown>

        <tds-text-field
            type="text"
            size="lg"
            state="default"
            label="Label"
            label-position="no label"
            no-min-width
            placeholder=""
            tds-aria-label="A text field component"
            required="false"
            autocomplete="off" style="padding-right: 20px;"
        ></tds-text-field>

         <tds-button
            type="button"
            variant="primary"
            size="lg"
            text="Confirmar Envio"
            animation="none"
            tds-aria-label="undefined"
            name=""
            value="" style="padding-right: 20px;"
        ></tds-button>

         <tds-button
            type="button"
            variant="primary"
            size="lg"
            text="Relatório de Críticas"
            animation="none"
            tds-aria-label="undefined"
            name="" 
            value="" style="padding-right: 20px;"
        ></tds-button>
    </div>
</div>